import { render, staticRenderFns } from "./PurchaseRequisition.vue?vue&type=template&id=2f31cdad"
import script from "./PurchaseRequisition.vue?vue&type=script&lang=js"
export * from "./PurchaseRequisition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports